import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from '../../components/ErrorBoundary';
import TemplateList from './components/TemplateList';
import TemplateBuilder from './components/TemplateBuilder';
import TemplatePreview from './components/TemplatePreview';
import PublishedList from './components/PublishedList';
import TemplateComplete from './components/TemplateComplete';
import ResponseView from './components/ResponseView';
import Library from './components/Library';

function LibraryModule() {
  return (
    <ErrorBoundary>
      <Routes>
        {/* Library main page with tabs */}
        <Route path="/" element={<Library />} />
        <Route path="/templates" element={<Library />} />
        <Route path="/published" element={<Library />} />
        <Route path="/completed" element={<Library />} />

        {/* Template management */}
        <Route path="/builder/:id" element={<TemplateBuilder />} />
        <Route path="/preview/:id" element={<TemplatePreview />} />
        <Route path="/complete/:id" element={<TemplateComplete />} />

        {/* Response viewing */}
        <Route path="/responses/:id" element={<ResponseView />} />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/library/templates" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default LibraryModule;
